document.addEventListener('DOMContentLoaded', function () {
  let collectionDropdown = document.querySelector('.option-value');

  async function fetchAndAppendMeta(handle, featuresContainer) {
    try {
      const response = await fetch(`/products/${handle}?view=new-template`, {
        credentials: 'same-origin',
        method: 'GET'
      });
      const html = await response.text();
      let checkoutContainer = document.createElement('div');
      checkoutContainer.innerHTML = html;

      let metaData = checkoutContainer.querySelector('.meta-data-specs');
      if (metaData && featuresContainer) {
        featuresContainer.append(metaData);
      }
    } catch (error) {
      console.error('Fetch error:', error);
    }
  }

  function fetchAndPopulateProducts(collection) {
    let apiURL = `/collections/${collection}/products.json?limit=250`;

    fetch(apiURL)
      .then((response) => response.json())
      .then((data) => {
        let products = data.products;
        if (!products || products.length === 0) return;

        document.querySelectorAll('.title-product').forEach((dropdown, index) => {
          let optionHTML = products
            .map((product) => `<option value="${product.handle}" productId="${product.id}">${product.title}</option>`)
            .join('');

          dropdown.innerHTML = `<option value="">Select Product</option>` + optionHTML;

          dropdown.addEventListener('change', async function () {
            updateDisabledOptions();
            let selectedHandle = this.value;
            console.log(selectedHandle, "selectedHandleselectedHandle");
            let selectedProduct = products.find((p) => p.handle === selectedHandle);
            if (selectedProduct) {
              let cardContainer = document.querySelectorAll('.card-container-trimmer')[index];
              renderCard(cardContainer, selectedProduct);
              
              const featuresSpecs = cardContainer.querySelector('.features');
              fetchAndAppendMeta(selectedHandle, featuresSpecs);

              console.log(selectedProduct, "selectedProduct");
            }
          });

          if (index === 0 && products.length > 0) {
            let cardContainer = document.querySelectorAll('.card-container-trimmer')[index];
            renderCard(cardContainer, products[0]);
            const featuresSpecs = cardContainer.querySelector('.features');
            fetchAndAppendMeta(products[0].handle, featuresSpecs);
            dropdown.selectedIndex = 1;
          }

          if (index === 1 && products.length > 1) {
            let cardContainer = document.querySelectorAll('.card-container-trimmer')[index];
            renderCard(cardContainer, products[1]);
            const featuresSpecs = cardContainer.querySelector('.features');
            fetchAndAppendMeta(products[1].handle, featuresSpecs);
            dropdown.selectedIndex = 2;
          }
        });

        updateDisabledOptions();
      })
      .catch((error) => {
        console.error('Error fetching products:', error);
      });
  }

  function updateDisabledOptions() {
    const allDropdowns = document.querySelectorAll('.title-product');
    let selectedValues = Array.from(allDropdowns)
      .map((dropdown) => dropdown.value)
      .filter((value) => value);

    allDropdowns.forEach((dropdown) => {
      let options = dropdown.querySelectorAll('option');
      options.forEach((option) => {
        if (selectedValues.includes(option.value) && option.value !== dropdown.value) {
          option.disabled = true;
        } else {
          option.disabled = false;
        }
      });
    });
  }

  function renderCard(container, product) {
    const productImage = product.images?.[0]?.src || '';
    const productTitle = product.title || 'No title available';
    const productPrice = product.variants?.[0]?.price || '';
    const productComparePrice = product.variants?.[0]?.compare_at_price || '';
    const productVariantId = product.variants?.[0]?.id || '';
    container.innerHTML = `
      <div class="card-trimmer">
        <div class="card-image-trimmer">
          <img src="${productImage}" alt="${productTitle}">
        </div>
        <div class="details-trimmer">
          <h3>${productTitle}</h3>
          <div class="price">
            ₹${productPrice}
          </div>
          <form action="/cart/add" method="post" class="variants custom-atc-trimmer" data-product-id="${productVariantId}" enctype="multipart/form-data">
            <input type="hidden" name="id" value="${productVariantId}">
            <input type="hidden" name="quantity" value="1">
            <div class="atc-btn-alignment">
              <button type="submit" class="custom-atc-btn custom-atc-trimmer-btn" name="add">Add To Cart</button>
            </div>
          </form>
        </div>
        <div class="features"></div>
      </div>
    `;
  }

  let defaultCollection = collectionDropdown?.value || 'all';
  if (collectionDropdown) {
    fetchAndPopulateProducts(defaultCollection);
    collectionDropdown.addEventListener('change', function () {
      fetchAndPopulateProducts(this.value);
      console.log(this.value, "this.value");
    });
  }
});